import { environmentConfigItems, getEnvironment } from "./all-environments-config.model";
import { EnvironmentNames } from "./models/environment-names.enum";

export const environment = {
  production: false,
 appTitle: 'AviatorPro',
  baseTitle: 'AviatorPro',
  environment: getEnvironment(EnvironmentNames.test),
  altEnvironment: getEnvironment(EnvironmentNames.dev),

  tenantKey: '16970b66-9788-4e12-aeb3-36bda56bd32f',

  allowConfiguration: true,
  enableConsoleLogging: true,
  disableLocalStorageCaching: true,

  googleAnalyticsTrackingToken: null,
  postHog: {
    enabled: false,
    projectToken: null,
    apiHost: null,
    uiHost: null,
  },
  showContactUs: true,
  contactUsEmail: 'noreply@devwareinc.com',
  disabledUserInactvityTimeout: false,
  enableTagManagerCall: false,
  tagManagerConversionEvent: 'AW-17048822730/npmUCPiv3_oaEMrHwcE_',
  pdfViewerScriptUrl: '/assets/scripts/pdfjs',
  turnOffBeaconForQuizzes: true,
  turnOffBeaconForVideos: true,
 
  showManageUsersCallout: false,
  allowRegistrationVerificationSkip: true,
  videoDiagnosticsUserIds: [],
  videoDiagnosticsUserNames: [],
  videoDiagnosticsUserEmails: ['anthony.monsees@gmail.com'],
  //pdfViewerScriptUrl: 'https://files.devwareapps.com/scripts/pdfjs',

};
